import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { BodyTextMedium } from '../../Typography/Typography';
import { BaseCheckbox } from '../FormInputCheckbox/BaseCheckbox';
import { filterOptions } from './utils';
import * as styles from './BaseSelect.module.scss';
export const Dropdown = ({ multi, options, selections, inputValue, highlightedIndex, onChange, onMouseEnter, onClick, }) => {
    const filteredOptions = filterOptions(options, inputValue);
    const hasOptions = filteredOptions.length > 0;
    const renderOption = (option, optionIndex) => {
        const isHighlighted = optionIndex === highlightedIndex;
        const isChecked = Boolean(selections.find(selection => selection.value === option.value));
        const onClickHandler = () => {
            onClick(option);
        };
        const onChangeHandler = () => onChange(option);
        const onMouseEnterHandler = () => onMouseEnter(optionIndex);
        return (_jsx("li", { role: "option", "aria-selected": isChecked, onMouseEnter: onMouseEnterHandler, className: clsx(styles.optionsItem, isHighlighted && styles.optionsItemHighlighted), children: multi ? (_jsx(BaseCheckbox, { label: option.label, value: isChecked, onChange: onChangeHandler })) : (_jsx("div", { className: styles.optionsItemText, onClick: onClickHandler, children: _jsx(BodyTextMedium, { as: "span", fontColor: "gray65", children: option.label }) })) }, option.value));
    };
    if (!hasOptions) {
        return (_jsx("li", { className: clsx(styles.optionsItem, styles.optionsItemEmpty), children: _jsx(BodyTextMedium, { as: "span", children: "No options" }) }));
    }
    return (_jsx("ul", { role: "listbox", className: styles.options, children: filteredOptions.map(renderOption) }));
};
